import { useState, useEffect } from "react";
import { VscCalendar, VscLocation, VscCreditCard, VscFile } from "react-icons/vsc";
import "./Events.css";

function Events() {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filterType, setFilterType] = useState("all");

    useEffect(() => {
        // Fake event data
        const fakeEvents = [
            {
                id: 1,
                name: "Toronto FC Combine 2026",
                organization: "Toronto Football Club",
                date: "2026-03-15",
                location: "Toronto, ON",
                type: "combine",
                fee: "paid",
                amount: "$250",
                description: "Official Toronto FC U-20/U-23 combine. Compete against top talent from across Canada. Tests include 40-yard dash, vertical jump, agility drills, and small-sided matches.",
                positions: ["Forward", "Midfielder", "Defender", "Goalkeeper"],
                capacity: 120,
                registered: 87,
                applicationProcess: false,
            },
            {
                id: 2,
                name: "Vancouver Whitecaps Academy Trials",
                organization: "Vancouver Whitecaps FC",
                date: "2026-04-01",
                location: "Vancouver, BC",
                type: "trials",
                fee: "free",
                amount: "Free",
                description: "Official Whitecaps Academy trials open to players U-18 and U-20. Multiple sessions available. Please register in advance.",
                positions: ["Forward", "Midfielder", "Defender"],
                capacity: 200,
                registered: 145,
                applicationProcess: false,
            },
            {
                id: 3,
                name: "Soccer Talent Showcase - Atlantic Region",
                organization: "Scout Network Canada",
                date: "2026-03-28",
                location: "Halifax, NS",
                type: "showcase",
                fee: "paid",
                amount: "$150",
                description: "Elite performance showcase featuring scouts from professional leagues. Limited spots. Application required - submit video highlights and stats.",
                positions: ["Forward", "Midfielder", "Defender"],
                capacity: 60,
                registered: 52,
                applicationProcess: true,
            },
            {
                id: 4,
                name: "Montreal Impact Youth Finals",
                organization: "Montreal Impact",
                date: "2026-05-10",
                location: "Montreal, QC",
                type: "tournament",
                fee: "free",
                amount: "Free",
                description: "End of season youth finals tournament. Teams of 11. Pre-tournament registration required. Support your local community club.",
                positions: ["Forward", "Midfielder", "Defender", "Goalkeeper"],
                capacity: 250,
                registered: 198,
                applicationProcess: false,
            },
            {
                id: 5,
                name: "Elite Academy Selection Camp",
                organization: "Football Canada",
                date: "2026-06-05",
                location: "Toronto, ON",
                date_end: "2026-06-07",
                type: "academy",
                fee: "free",
                amount: "Free",
                description: "3-day national academy selection camp. Top prospects only. Invitation required based on performance metrics and rankings. Scouts from MLS, CPL, and USL clubs present.",
                positions: ["Forward", "Midfielder", "Defender", "Goalkeeper"],
                capacity: 80,
                registered: 72,
                applicationProcess: true,
            },
            {
                id: 6,
                name: "Weekend Scrimmage Series - Spring",
                organization: "Local Youth League",
                date: "2026-04-05",
                location: "Ottawa, ON",
                type: "scrimmage",
                fee: "paid",
                amount: "$75/event",
                description: "Weekly scrimmage series every Sunday for 8 weeks. Drop-in friendly matches for skill development. No registration needed - just show up!",
                positions: ["Forward", "Midfielder", "Defender", "Goalkeeper"],
                capacity: 150,
                registered: 103,
                applicationProcess: false,
            }
        ];

        setLoading(true);
        setTimeout(() => {
            setEvents(fakeEvents);
            setLoading(false);
        }, 300);
    }, []);

    const filtered = filterType === "all" 
        ? events 
        : events.filter(e => e.type === filterType);

    return (
        <main className="events-page">
            <div className="events-container">
                <header className="events-header">
                    <h1>Soccer Events & Trials</h1>
                    <p>Find combines, trials, showcases, and tournaments near you</p>
                </header>

                <div className="events-filters">
                    <button
                        className={`events-filter-btn ${filterType === "all" ? "active" : ""}`}
                        onClick={() => setFilterType("all")}
                    >
                        All Events
                    </button>
                    <button
                        className={`events-filter-btn ${filterType === "combine" ? "active" : ""}`}
                        onClick={() => setFilterType("combine")}
                    >
                        Combines
                    </button>
                    <button
                        className={`events-filter-btn ${filterType === "trials" ? "active" : ""}`}
                        onClick={() => setFilterType("trials")}
                    >
                        Trials
                    </button>
                    <button
                        className={`events-filter-btn ${filterType === "showcase" ? "active" : ""}`}
                        onClick={() => setFilterType("showcase")}
                    >
                        Showcases
                    </button>
                    <button
                        className={`events-filter-btn ${filterType === "academy" ? "active" : ""}`}
                        onClick={() => setFilterType("academy")}
                    >
                        Academies
                    </button>
                </div>

                {loading ? (
                    <div className="events-loading">
                        <p>Loading events...</p>
                    </div>
                ) : filtered.length === 0 ? (
                    <div className="events-empty">
                        <p>No events found.</p>
                    </div>
                ) : (
                    <div className="events-grid">
                        {filtered.map((event) => (
                            <div key={event.id} className="event-card">
                                <div className="event-card-header">
                                    <div className="event-icon">{event.image}</div>
                                    <div className="event-type-badge">{event.type}</div>
                                </div>

                                <h3 className="event-title">{event.name}</h3>
                                <p className="event-organization">{event.organization}</p>

                                <div className="event-meta">
                                    <div className="event-meta-item">
                                        <VscCalendar size={16} />
                                        <span>{new Date(event.date).toLocaleDateString()}</span>
                                    </div>
                                    <div className="event-meta-item">
                                        <VscLocation size={16} />
                                        <span>{event.location}</span>
                                    </div>
                                    <div className="event-meta-item">
                                        <VscCreditCard size={16} />
                                        <span className={event.fee === "free" ? "event-free" : "event-paid"}>
                                            {event.amount}
                                        </span>
                                    </div>
                                </div>

                                {event.applicationProcess && (
                                    <div className="event-application-badge">
                                        <VscFile size={14} /> Application Required
                                    </div>
                                )}

                                <div className="event-positions">
                                    {event.positions.slice(0, 2).map((pos) => (
                                        <span key={pos} className="event-position-tag">
                                            {pos}
                                        </span>
                                    ))}
                                    {event.positions.length > 2 && (
                                        <span className="event-position-tag">+{event.positions.length - 2}</span>
                                    )}
                                </div>

                                <div className="event-capacity">
                                    <div className="event-capacity-bar">
                                        <div
                                            className="event-capacity-fill"
                                            style={{ width: `${(event.registered / event.capacity) * 100}%` }}
                                        />
                                    </div>
                                    <p className="event-capacity-text">
                                        {event.registered} / {event.capacity} registered
                                    </p>
                                </div>

                                <button
                                    className="event-view-btn"
                                    onClick={() => setSelectedEvent(event)}
                                >
                                    View Details
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {selectedEvent && (
                <div className="event-modal-overlay" onClick={() => setSelectedEvent(null)}>
                    <div className="event-modal" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="event-modal-close"
                            onClick={() => setSelectedEvent(null)}
                        >
                            ✕
                        </button>

                        <div className="event-modal-header">
                            <div className="event-modal-icon">{selectedEvent.image}</div>
                            <div>
                                <h2>{selectedEvent.name}</h2>
                                <p className="event-modal-org">{selectedEvent.organization}</p>
                            </div>
                        </div>

                        <div className="event-modal-meta">
                            <div className="event-modal-meta-item">
                                <VscCalendar size={18} />
                                <div>
                                    <p className="label">Date</p>
                                    <p className="value">{new Date(selectedEvent.date).toLocaleDateString()} {selectedEvent.date_end && `- ${new Date(selectedEvent.date_end).toLocaleDateString()}`}</p>
                                </div>
                            </div>
                            <div className="event-modal-meta-item">
                                <VscLocation size={18} />
                                <div>
                                    <p className="label">Location</p>
                                    <p className="value">{selectedEvent.location}</p>
                                </div>
                            </div>
                            <div className="event-modal-meta-item">
                                <VscCreditCard size={18} />
                                <div>
                                    <p className="label">Fee</p>
                                    <p className="value">{selectedEvent.amount}</p>
                                </div>
                            </div>
                        </div>

                        <div className="event-modal-description">
                            <h3>About This Event</h3>
                            <p>{selectedEvent.description}</p>
                        </div>

                        <div className="event-modal-positions">
                            <h3>Positions</h3>
                            <div className="event-modal-positions-list">
                                {selectedEvent.positions.map((pos) => (
                                    <span key={pos} className="event-position-badge">
                                        {pos}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="event-modal-footer">
                            <button className="event-modal-apply">
                                Register Now
                            </button>
                            <button
                                className="event-modal-cancel"
                                onClick={() => setSelectedEvent(null)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </main>
    );
}

export default Events;
